import {
	parseAllowLinks,
	parseEmbedTitle,
} from "../../../markdown_parser/markdown";
import "./discord_embed.scss";

export function DiscordNativeEventComponent(props: { description?: string }) {
	return (
		<div className="flex w-full max-w-full flex-col gap-2 rounded-xl border border-[#3B3B40] bg-base-dark p-6">
			{props.description && (
				<div className="description w-full break-words text-sm">
					{parseAllowLinks(
						props.description.replaceAll("\n", "  \n")
					)}
				</div>
			)}
		</div>
	);
}
